<!--
 * @Date: 2022-09-24 19:19:03
 * @LastEditTime: 2022-12-13 19:21:37
 * @Description: 关爱老人 分享海报
-->
<template>
  <div class="bill-wrapper">
    <div
      v-if="!showBill"
      ref="credentialsShare"
      class="qingxin-disseminate-bill"
    >
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/10/18/2075/752cf812f57f_w1125_h747_.png"
        alt=""
        class="bg"
      />
      <div class="card-wrapper">
        <img
          src="https://resource.chunyu.mobi/@/media/images/2022/10/18/6981/a9a36b252bb2_w285_h246_.png"
          alt=""
          class="little-pi"
        />
        <div class="img-wrapper">
          <img :src="imageSrc[0]" alt="" class="img" />
        </div>
        <div class="text-wrapper">
          <div
            v-if="!billCreating"
            class="change-button"
            @click="randomGetText"
          >
            <span class="tips">
              点击下方文字可修改，或点我换一换
            </span>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAGRklEQVRoBe1Za2wUVRQ+Z3ZWRZ4KFoooqJBud8FG6wNUfITHD7VqlKAmIvYFhkStBE34Y1CDQUHBIBHZFoI1aEgECxqRKBARkABKkNJtRAIJAXxSsEDT7szxm4G7nZ3uY7ZdpD92ks2559x7v3vOPeeee2aWKPfkdiC3A7kduJQ7wF1dXHYX+2lvyx1ExjgSugu/wcSURyL9iPlv4B/D7zixHABfR2VP7WSeY3Z1XTW/0wbIyqJrqa3lBSg8XYT6KcB0lJl/J+K1pMvbXBo5nG58uv6MDZCagt5k0DwoUSkk/nQLJOuHIa0wfgldTnN5asTyVKeejAyQjwJTER7zofg1yVZjhlrEJxFCJzG2fzrvsDWW6GmeFvkmGWYquWcDJBy4H0p9C+18bkAovQ3x/QVpvIluGLiPH9gSVWNk9Zge1HTqRmLjQRJ+jEhGA0NT/RbFfAOiWVzZsMgp99LOwICChdjNKicoFq4jXZ/LpfW7nPJUbVkWDBGb80TkYfc44C3iysaX3fJUvHcDqgMlYso6Cwzx2wwyjSsjn6YCT9Un1cFxZBqr4I085zhmbQY88aFTlqrt2QALRKpDd5MZHUXsX8uV+5FNuvbIx6HrqSW6DkYUKSSciSj5ZCKXN25WslQ0IwNSAXW2Tz65sw+dPbUDiSGoMGDEccrvOZxL9pxVsmQ07jAlG3Qx5fzMztOk+0sQlrFUCmPy6XjzTC/rXnIPKCWR5R7Hwf5c8TDoX/L1uInLfv5TyRLRhB6QmtBMWVbQav9qAp52IhF4JjIkhDUIne1qDozBhXluhuKT0Q4GSLiwHAd1AQ6W3/qRKQtk+cjrkgFkVa7x7Hg8wb2R+omFkKwOXUanzPdFzOfdU+DO3aQPGsulW1rcfdnmEUqHsftDFS5r2jCuaDiieDe1PSC1hfnUZGxOpLw1AYC3kXHCc252L5IhX+ca/5CLj2N1XCi30DnzK/vkx3XFM7jEnpPqwB6uiHwQ39M1TsIjB5IYb6Hc7kOizQHdiB17MYZqynCrjXNZhIsvSPoVX3Pp3ibVr5GYtemUV4PJpPckHBwb47PSaFssZJbBy5NQYnyP94r4CpdlMM5lFRnRnzBmFbWd22GH+4W1YQD1VnqgFhHE+0HFWxSi3xQPQ/3YrcWKzwoVylc4UPBqeMEdqqMR2guRUM6HO1GAmmSEmgMhV1mXCJQ/islPoOOo6rSp5p+Kk366XcZXtbez0GLtDbt8uAAFIwY5UVFAxg60Jbc3eMjQ2CbHspCaJOGCzzDpScUz+4vIZ+SRIbWQWe61irg1qj8bVKoLpyCUV2LdDvo48W3ldZrgfJPTnQPstjDeYeEw9SAGuaxhA9iYq1VXtijSZC0SRF8c3qThiQjZR6RP5NL4ItKOqzhFNPslvF1knfz/4bGyG0rp1xItZd/Qeo/7ElXAHQ0Q2u0CecTFXzQW7wFvYqc3ORdgjQ6hMkXYtKdOZ39HA/qO2opY+yc2iOUeWRnoH+MvdqMiMh5GNCL7GdDjCPXRC1OV1QkPDa5zHCh5VukKoDk4uK8rvjvRjh6wtGNf/Kui0Cz7xuxOml/QJaEBXFG/Aa75QemLC6wXSdt8xXcnmtAAW0Efv+pUFIl1ilQXvOSUdYd2UgO4PLIDse8OpXdx6aSt0f9PwxIeYqUAiqZeKLO3I4RGKRkmmKRps3H5vKNknaW49V/B3MmowFrxUWw6MPdnipXSAAtMVgSGUZvsQggNcILDO2vJ55/FZb8ccsq9tGVV8QA607wEpcNkNR6pcys+at2reK80rQEWkKwI3U5RYz1S60AnMG7INlQvS8nnW8pl9QecfYna578DGVWYMw1YPZ1jsCE/IlWPccq8tD0ZYAFJ+OYhJK11CKdbEwFDAVSI8iWq3oMopY6hbPwL9X0/hEceXlKCCLwJzlB0YmD3W2DUeK5o3OaUe2l7NsACk/XFV9KJMwvRKof7O3zk9bKgewyUr6G+ehVPrm9293nhMzJAAcryUJAMw/pAW6JkmVIo/h1eUeZ6/YSYDL9TBigwlBzFaE+CRx6FRwqVPBnFmTmMUNlImoShuLtoTDYtpbxLBjiRZUXhCIoi3TL+IzPx05C1hJsQ/3/gTe8E/lLayaUNvzrn5Nq5HcjtQG4H6D+u2ybTQk9tBgAAAABJRU5ErkJggg=="
              alt=""
              class="change-button-icon"
            />
          </div>
          <div class="text" @click="onEditClick">
            {{ showText }}
          </div>
          <img :src="tagImage" alt="" class="tag-image" />
        </div>
        <div class="split" />
        <div class="bottom-info">
          <div class="qingxin-text">
            <span class="name">恭喜 {{ data.nickname }}</span>
            <span> 成为第{{ data.attend_num }}位小雨滴</span>
            <span>
              快和我一起晒老年酷照吧！
            </span>
            <img
              class="tip-wrapper"
              src="https://resource.chunyu.mobi/@/media/images/2022/10/18/7f7d/80b264e97e71_w516_h78_.png"
            />
          </div>
          <div class="qr-wrapper">
            <img :src="data.qr_code" alt="" class="qr" />
          </div>
        </div>
      </div>
      <div v-if="showEdit" class="edit-wrapper">
        <div class="text-area-wrapper">
          <cube-textarea
            v-model="inputText"
            class="text-area"
            :autofocus="true"
            :maxlength="32"
            placeholder=""
          />
        </div>
        <div class="submit-button-wrapper">
          <div class="button" @click="submitText">确认</div>
        </div>
      </div>
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/10/18/fbd6/f0943a8e398b_w957_h204_.png"
        alt=""
        class="bottom-img"
      />
    </div>
    <div class="bottom-button">
      <UploadImg
        v-model="imageSrc"
        :visible.sync="isShowH5UploadLoading"
        :multiple="false"
        :upload-config="uploadConfig"
        class="upload-button"
        origin="reupload-button"
      >
        <template>
          <div class="left">重新选择</div>
        </template>
      </UploadImg>
      <div class="right" @click="getBill">生成海报分享好友</div>
    </div>
    <div v-show="showBill" class="bill-weixin">
      <img :src="bill" alt="" class="bill-image" />
      <div class="weixin-share-button">
        <span>长按保存海报</span>
        <p class="p-text">或右上角...分享好友</p>
      </div>
      <div class="white-div" />
    </div>
    <div v-if="shareDown" class="share-down">
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/10/19/0188/dc11f3c25a0c_w870_h957_.png"
        alt=""
        class="bg"
      />
      <div class="submit" @click="submitPost">
        一键发布
      </div>
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/09/30/02bf/ac6e28e1f5ca_w105_h102_.png"
        alt=""
        class="close"
        @click="shareDown = false"
      />
    </div>
    <!-- 上传loading -->
    <Loading v-show="isShowH5UploadLoading" class="loading" />
  </div>
</template>

<script>
import * as cyDetect from '@cy/detect';
import html2canvas from 'html2canvas';
import cyShare from '@cy/share';
import { doPoint, requestEvent } from '@/utils/index';
// eslint-disable-next-line import/no-extraneous-dependencies
import Loading from '@/components/Loading';
import auth from '@/services/auth';
// import Dom2Qiniu from '@/utils/dom2qiniu.js';
import {
  getQinxinDisseminateBillInfo,
  saveQinxinDisseminateBill,
  isLogin,
} from '@/services/index';
import { wxSdkSign } from '@/utils/wx';
import UploadImg from './components/UploadImg';

const wx = require('weixin-js-sdk');

export default {
  components: {
    UploadImg,
    Loading,
  },
  data() {
    return {
      isFromChunyu: cyDetect.isFromCYAll(),
      isFromWeixin: cyDetect.isFromWechat(),
      showText: '', // 展示文字
      inputText: '', // 输入文字
      data: {
        nickname: '',
        attend_num: 0,
        qr_code: '',
        tag_image_list: '',
        text_list: '',
      },
      tagImage: '', // 标签图片
      showEdit: false, // 展示编辑
      isShowH5UploadLoading: false, // loading
      imageSrc: [],
      bill: '', // 海报图
      showBill: false, // 展示海报
      billCreating: false, // 海报生成中
      uploadConfig: {
        // 上传配置
        validateOptions: {
          miniCount: 1,
          maxCount: 2, // 上传数量
          miniSize: '0',
          maxSize: '10240', // 文件大小
          typesCanBeSent: [
            'image/gif',
            'image/png',
            'image/jpeg',
            'image/bmp',
            'image/webp',
          ], // 文件类型
        },
      },
      shareDown: false, // 分享成功
    };
  },
  watch: {
    imageSrc(n) {
      console.log(n, 'n');
    },
  },
  mounted() {
    isLogin().then(res => {
      const { is_login } = res;
      if (!is_login) {
        requestEvent();
      } else {
        wxSdkSign();
        this.getData();
        // 监听hashchange，标识成功分享
        this.onHashChange();
        this.imageSrc = [window.sessionStorage.getItem('img')];
        if (this.imageSrc.length) {
          window.sessionStorage.removeItem('img');
        }
        this.doPagePoint('PageView', {
          activity_name: '海报传播活动',
          page_title: document.title,
        });
        this.onShare();
      }
    });
  },
  methods: {
    /**
     * 小程序分享成功通过hash传递
     */
    onHashChange() {
      let hash;
      // 监听hash变化
      window.addEventListener(
        'popstate',
        () => {
          if (window.location.hash) {
            hash = window.location.hash;
            console.log(hash, 'hash');
            if (hash === '#share') {
              this.shareDown = true;
            }
          }
        },
        false
      );
    },
    /**
     * 获取数据
     */
    getData() {
      getQinxinDisseminateBillInfo({
        alias: 'idop',
      }).then(resp => {
        console.log(resp, '海报数据');
        if (resp.error_code === 0) {
          this.data = resp;
          this.randomGetTagImg();
          this.randomGetText();
        } else {
          console.error('数据获取失败');
        }
      });
    },
    /**
     * 随机获取tag
     */
    randomGetTagImg() {
      if (this.data.tag_image_list) {
        const items = this.data.tag_image_list;
        this.tagImage = items[Math.floor(Math.random() * items.length)];
      }
    },
    /**
     * 随机获取文案
     */
    randomGetText() {
      if (this.data.text_list) {
        const items = this.data.text_list;
        this.showText = items[Math.floor(Math.random() * items.length)];
      }
    },
    /**
     * 点击编辑
     */
    onEditClick() {
      this.showEdit = true;
      this.inputText = this.showText;
    },
    /**
     * 确认文案
     */
    submitText() {
      this.showText = this.inputText;
      this.showEdit = false;
    },
    /**
     * 生成海报
     */
    getBill() {
      this.doPagePoint('AppClick', {
        activity_name: '海报传播活动',
        page_title: document.title,
        click_position: '生成海报',
      });
      this.billCreating = true;
      this.isShowH5UploadLoading = true;
      const toast = this.$createToast({
        time: 5000,
        txt: `海报生成中`,
        type: 'txt',
      });
      toast.show();
      const ap = this.$refs.credentialsShare;
      setTimeout(() => {
        html2canvas(ap, {
          allowTaint: true,
          useCORS: true,
          width: this.$refs.credentialsShare.scrollWidth,
          height: this.$refs.credentialsShare.clientHeight - 80,
        })
          .then(resp => {
            const base64Image = resp.toDataURL('image/jpeg');
            // 上传至七牛云获取图片url
            this.uploadQiNiu(base64Image).then(resp => {
              const { img_url } = resp;
              saveQinxinDisseminateBill({
                image: img_url,
                alias: 'idop',
              }).then(res => {
                console.log(res, 'res');
              });
              toast.hide();
              this.isShowH5UploadLoading = false;
              this.bill = img_url;
              this.billCreating = false;
              if (this.isFromChunyu) {
                const opt = {
                  img_base64: base64Image,
                  share_to: [
                    'weixin_haoyou',
                    'weixin_pengyouquan',
                    'qq',
                    'pic',
                  ],
                  userName: 'gh_681d3fd5683f', // 安卓
                  mini_id: 'gh_681d3fd5683f', // IOS
                  direct_share_to: 'pic',
                  path: `/pages/h5_webview/index?url=${encodeURIComponent(
                    window.location.href
                  )}`,
                };
                cyShare.app(opt);
                // 模拟分享成功
                setTimeout(() => {
                  this.shareDown = true;
                }, 500);
              } else {
                this.setWxMiniShare();
                this.showBill = true;
              }
            });
          })
          .catch(err => {
            console.log('海报生成失败', err);
          });
      }, 100);
    },
    async uploadQiNiu(image) {
      const res = await auth.getToken();
      const { token } = res;
      return new Promise((resolve, reject) => {
        this.uploadbase64ToQiniu(image, token)
          .then(resp => {
            console.log(resp, 'qiniudata');
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    uploadbase64ToQiniu(base64Str = '', token = '') {
      const base64 =
        base64Str.indexOf('base64,') !== -1
          ? base64Str.split('base64,')[1]
          : base64Str;

      const url = 'https://up-z0.qiniup.com/putb64/-1'; // 华北地区七牛仓库位置

      return new Promise((resolve, reject) => {
        // 发请求
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            const data = JSON.parse(xhr.response);
            if (data.success) resolve(data);
            else reject(data);
          }
        };
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.setRequestHeader('Authorization', `UpToken ${token}`);
        xhr.send(base64);
      });
    },
    /**
     * 发帖
     */
    submitPost() {
      console.log('发帖');
      this.doPagePoint('AppClick', {
        activity_name: '海报传播活动',
        page_title: document.title,
        click_position: '一键发布',
      });
      const url = `${window.location.origin}/v-m-community/send-invitation?qingxin=1`;
      if (this.isFromChunyu) {
        window.location.href = url;
      } else {
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            // 小程序环境
            wx.miniProgram.redirectTo({
              url: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
            });
          }
        });
      }
    },
    /**
     * 设置微信小程序分享
     */
    setWxMiniShare() {
      const { bill } = this;
      wx.miniProgram.getEnv(wxres => {
        if (wxres.miniprogram) {
          wx.miniProgram.postMessage({
            data: {
              img: bill, // 分享的图片展示
              title: '银发生活欢乐多！晒照片，赢锦鲤好礼', // 标题
              link: encodeURIComponent(
                `${window.location.origin}/v-m-general/caring-elder/entry`
              ), // 分享后点击卡片的跳转链接
              origin: 'qingxin-disseminate', // 来源
            },
          });
        }
      });
    },
    /**
     * 页面分享
     */
    onShare() {
      const params = {
        title: '银发生活欢乐多！晒照片，赢锦鲤好礼', // 标题
        mini_image:
          'https://resource.chunyu.mobi/@/media/images/2022/10/19/79b4/964098192d82_w1125_h1332_.jpg',
        img:
          'https://resource.chunyu.mobi/@/media/images/2022/10/19/79b4/964098192d82_w1125_h1332_.jpg', // 分享的图片展示
        link: `${window.location.origin}/v-m-general/caring-elder/entry`, // 分享后点击卡片的跳转链接
        userName: 'gh_681d3fd5683f', // 安卓
        mini_id: 'gh_681d3fd5683f', // IOS
        need_invitate_id: false,
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
      };
      cyShare.app(params);
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.bill-wrapper {
  min-height: 100vh;
  background: #ffe6a8;
}
.qingxin-disseminate-bill {
  display: inline-block;
  width: 100vw;
  min-height: calc(100vh - 2.4rem);
  padding-bottom: 3.1rem;
  background: #ffe6a8;
  .bg {
    position: absolute;
    z-index: 0;
    width: 100vw;
  }
  .card-wrapper {
    position: relative;
    box-sizing: border-box;
    width: rem(335);
    margin: rem(55) auto 0 auto;
    padding: rem(15) rem(15) rem(30) rem(15);
    background: #fff;
    border-radius: rem(20);
    box-shadow: 0 3px 12px 0 #ffd3b6;
    .little-pi {
      position: absolute;
      top: -0.7rem;
      right: -0.29rem;
      width: rem(95);
      height: rem(82);
    }
    .img-wrapper {
      width: 100%;
      margin-bottom: rem(15);
      .img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: rem(15);
      }
    }
    .text-wrapper {
      margin-bottom: rem(15);
      .change-button {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        width: rem(275);
        height: rem(24);
        margin-bottom: rem(10);
        padding: rem(4) rem(12);
        color: #fe9a27;
        font-size: rem(14);
        white-space: nowrap;
        border: 1px solid #fe9a27;
        border-radius: rem(12);
      }
      .change-button-icon {
        width: rem(16);
        margin-left: rem(4);
      }
      .text {
        display: -webkit-box;
        margin-bottom: rem(14);
        overflow: hidden;
        color: #323232;
        font-weight: bold;
        font-size: rem(18);
        line-height: 1.4;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .tag-image {
        width: rem(104);
        height: rem(25);
        object-fit: contain;
      }
    }
    .split {
      margin-bottom: rem(20);
      border: 0.5px dashed #979797;
    }
    .bottom-info {
      display: flex;
      .qingxin-text {
        color: #323232;
        font-size: 16px;
        .name {
          display: block;
        }
        span {
          display: inline-block;
          line-height: rem(25);
        }
        .tip-wrapper {
          width: rem(172);
          height: rem(26);
        }
      }
      .qr-wrapper {
        width: rem(108);
        height: rem(108);
        margin-left: rem(20);
        padding: rem(5);
        background: #ffe6a8;
        border-radius: rem(8);
        .qr {
          width: rem(98);
          height: rem(98);
        }
      }
    }
  }
  .bottom-img {
    position: relative;
    display: block;
    width: rem(323);
    margin: rem(-23) auto 0 auto;
  }

  .edit-wrapper {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    .text-area-wrapper {
      width: rem(345);
      height: rem(128);
      margin: 0 auto;
      padding: rem(20) rem(15);
      background: #fff;
      border-top-left-radius: rem(8);
      border-top-right-radius: rem(8);
      .text-area {
        height: rem(80);
        color: #323232;
        font-size: rem(16);
        border: none;
      }
    }
    .submit-button-wrapper {
      width: rem(345);
      height: rem(60);
      margin: 0 auto;
      padding: rem(8);
      background: #fff;
      border-bottom-right-radius: rem(8);
      border-bottom-left-radius: rem(8);
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
      .button {
        width: rem(165);
        height: rem(44);
        margin: 0 auto;
        color: #fff;
        font-weight: bold;
        font-size: rem(16);
        line-height: rem(44);
        text-align: center;
        background: #ff8400;
        border-radius: rem(22);
      }
    }
  }
  .special-btn {
    width: 100px;
    height: 100px;
  }
  .cube-textarea_active::after {
    border-color: #ffae83;
  }
}
.bottom-button {
  position: fixed;
  bottom: 0;
  z-index: 1;
  display: flex;
  width: 100%;
  height: rem(93);
  background: #fff;
  .upload-button {
    position: relative;
    width: rem(130);
    height: rem(60);
    color: #f80;
    font-weight: bold;
    font-size: 16px;
    line-height: rem(60);
    text-align: center;
  }
  .right {
    flex: 1;
    height: rem(60);
    color: #fff;
    font-weight: bold;
    font-size: rem(16);
    line-height: rem(60);
    text-align: center;
    background: #f80;
  }
}
.bill-weixin {
  position: fixed;
  top: 0;
  z-index: 300;
  height: 100vh;
  padding-bottom: rem(93);
  overflow: scroll;

  .bill-image {
    width: 100vw;
    min-height: calc(100vh - 2rem);
  }
  .weixin-share-button {
    position: fixed;
    bottom: 0.88rem;
    width: 100vw;
    height: rem(60);
    padding-top: rem(12);
    color: #fff;
    font-weight: bold;
    font-size: rem(16);
    text-align: center;
    background: #ff8400;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
    .p-text {
      line-height: 0;
    }
  }
  .white-div {
    position: fixed;
    bottom: 0;
    z-index: 300;
    width: 100vw;
    height: rem(33);
    background: #fff;
  }
}
.loading {
  position: absolute;
  top: 199px;
  left: 50%;
}
.share-down {
  position: fixed;
  top: 0;
  z-index: 300;
  width: 100vw;
  min-height: 100vh;
  padding: rem(103) rem(43) 0 rem(43);
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .bg {
    width: rem(290);
  }
  .submit {
    position: absolute;
    top: rem(347);
    left: rem(62);
    width: rem(250);
    height: rem(44);
    color: #fff;
    font-size: rem(16);
    line-height: rem(44);
    text-align: center;
    background-image: linear-gradient(270deg, #f50 0%, #ff8400 100%);
    border-radius: rem(22);
  }
  .close {
    position: absolute;
    top: rem(440);
    left: rem(172);
    width: rem(37);
  }
}
</style>
